import CardHeader from '@mui/material/CardHeader';
export default CardHeader;
